const AuthAccountTypes = {
    FACEBOOK: 'LOGIN_FACEBOOK',
    GOOGLE: 'LOGIN_GOOGLE',
    UMS: 'LOGIN_UMS',
    SIGNUP: 'SIGNUP',
    EXPEDIA: 'LOGIN_EXPEDIA',

    isValid(account) {
        return (typeof this.GOOGLE === account ||
            this.FACEBOOK === account ||
            this.UMS === account ||
            this.SIGNUP === account ||
            this.EXPEDIA === account
        );
    },

    isNotUndefined(account) {
        return (typeof account !== 'undefined');
    }
};
export default AuthAccountTypes;
